import styled from 'styled-components'

const BedroomCount = styled.div.attrs(({ n }) => ({
  children: n === 0 ? 'STUDIO' : `${n} BED`,
}))`
  font-size: 0.7em;
`

export default BedroomCount
